var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 54,
    viewBox: "0 0 13 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 53.3327C4.13975 53.3327 5.33366 52.1388 5.33366 50.666C5.33366 49.1933 4.13975 47.9993 2.66699 47.9993C1.19423 47.9993 0.000325441 49.1933 0.000325441 50.666C0.000325441 52.1388 1.19423 53.3327 2.66699 53.3327ZM2.66699 5.33268C4.13975 5.33268 5.33366 4.13877 5.33366 2.66602C5.33366 1.19326 4.13975 -0.000652313 2.66699 -0.000652313C1.19423 -0.000652313 0.000325441 1.19326 0.000325441 2.66602C0.000325441 4.13877 1.19423 5.33268 2.66699 5.33268ZM2.66699 50.666L3.09269 50.9283C8.97769 41.3762 12.1488 33.873 12.2373 26.4124C12.326 18.9426 9.32453 11.606 3.081 2.38567L2.66699 2.66602L2.25298 2.94636C8.45094 12.0994 11.3225 19.2301 11.2374 26.4006C11.1522 33.5803 8.1025 40.8903 2.2413 50.4037L2.66699 50.666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.528dea110404eb0442511e663e893816.svg";
export { ForwardRef as ReactComponent };